import { render, staticRenderFns } from "./template.html?vue&type=template&id=2c27de44&external"
import script from "./component.vue?vue&type=script&lang=js"
export * from "./component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src696773760/src/codestar-connections.ap-northeast-1.amazonaws.com/git-http/685534022793/ap-northeast-1/04f8861f-389a-48e5-bae0-9e3baa814fbd/lvgs/project-LPMT/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c27de44')) {
      api.createRecord('2c27de44', component.options)
    } else {
      api.reload('2c27de44', component.options)
    }
    module.hot.accept("./template.html?vue&type=template&id=2c27de44&external", function () {
      api.rerender('2c27de44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/views/common/object/component/form/elementLp1/fetchSuggestSelect/component.vue"
export default component.exports